function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons",
  transform: "translate(-88.000000, -187.000000)",
  fill: "#003246",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/menu",
  transform: "translate(88.000000, 187.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.66666667,0 C7.85076158,0 8,0.223857625 8,0.5 C8,0.772854966 7.85429373,0.994662647 7.67322647,0.999905112 L7.66666667,1 L0.333333333,1 C0.149238417,1 0,0.776142375 0,0.5 C0,0.227145034 0.145706272,0.00533735342 0.326773528,9.48880869e-05 L0.333333333,0 L7.66666667,0 Z",
  id: "Path",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.66666667,3 C7.85076158,3 8,3.22385763 8,3.5 C8,3.77285497 7.85429373,3.99466265 7.67322647,3.99990511 L7.66666667,4 L0.333333333,4 C0.149238417,4 0,3.77614237 0,3.5 C0,3.22714503 0.145706272,3.00533735 0.326773528,3.00009489 L0.333333333,3 L7.66666667,3 Z",
  id: "Path",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.66666667,6 C7.85076158,6 8,6.22385763 8,6.5 C8,6.77285497 7.85429373,6.99466265 7.67322647,6.99990511 L7.66666667,7 L0.333333333,7 C0.149238417,7 0,6.77614237 0,6.5 C0,6.22714503 0.145706272,6.00533735 0.326773528,6.00009489 L0.333333333,6 L7.66666667,6 Z",
  id: "Path",
  fill: "currentColor"
})))));

var SvgHamburger = function SvgHamburger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHamburger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger.49b86ffd.svg";
export { ForwardRef as ReactComponent };